import { type ApolloError, useSubscription } from '@apollo/client'
import { useState } from 'react'

import logger from '@/utils/logger'

import { useUser } from '@/client/context/user'
import { UNANSWERED_LIVE_HELP_REQUESTS_COUNT_SUBSCRIPTION } from '@/client/services/hasura'
import type {
  UnansweredLiveHelpRequestsCountSubscription,
  UnansweredLiveHelpRequestsCountSubscriptionVariables,
} from '@/client/services/hasura/generated/graphql'

export default function useUnansweredLiveHelpRequestsCount({
  tutorWorldIds,
}: {
  tutorWorldIds: number[]
}): {
  loading: boolean
  error: ApolloError | null
  count: number
} {
  const user = useUser()

  const [count, setCount] = useState<number | null>(null)

  const { loading, error = null } = useSubscription<
    UnansweredLiveHelpRequestsCountSubscription,
    UnansweredLiveHelpRequestsCountSubscriptionVariables
  >(UNANSWERED_LIVE_HELP_REQUESTS_COUNT_SUBSCRIPTION, {
    skip: tutorWorldIds.length === 0,
    variables: {
      userId: user.id,
      worldIds: tutorWorldIds,
    },
    onData: data => {
      const aggregate = data.data.data?.live_help_request_aggregate?.aggregate
      setCount(aggregate?.count ?? 0)
    },
    onError: err => {
      logger.warning('Error fetching unanswered live help requests count', { err })
    },
  })

  return {
    loading: loading && count == null,
    error,
    count: count ?? 0,
  }
}
